import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router'



class RegisterConfirmation extends Component {
    
   constructor(props) { 
        super(props);
        this.state={}
   }

   render() {

        return (
            <Container >
              <div className="page-register-confirmation">

                    <Row>
                        <Col>
                            <Link to="/"><div className="bloc-right center close">X</div></Link>
                        </Col>
                    </Row>

                    <div className="page-register-confirmation-container">
                        <Row>
                            <Col>
                                <div className="confirmation-title">Un email contenant un lien de réinitialisation de mot de passe vient de vous être envoyer. Veuillez verifier votre boite mail</div>
                                
                            </Col>
                        </Row>

                    </div>

                    <div  className="page-register-confirmation-container-action">
                      <Row>
                          <Col>
                              <Link to="/login/"><Button className="btn-green">Retour</Button></Link>
                          </Col>
                      </Row>
                    </div>

                </div>
            </Container>
        )
    }
}

export default RegisterConfirmation


// WEBPACK FOOTER //
// ./src/home/components/ResetPasswordConfirmation.js